import React from 'react';
import ProtectedRoute from '../../Components/ProtectedRoute';
import { VectorQuantificationRelatory, VectorQuantificationRelatoryViewController } from "../../Screen/VectorQuantificationRelatory/VectorQuantificationRelatoryViewController";
import { VectorQuantificationRelatoryViewModel } from '../../Screen/VectorQuantificationRelatory/VectorQuantificationRelatoryViewModel';
import { IndexCoordinatorDelegate } from "../IndexCoordinator";

export class VectorQuantificationRelatoryCoordinator implements IndexCoordinatorDelegate, VectorQuantificationRelatory {

    getRoute(): JSX.Element[] {
        return [
            this.routeVectorQuantificationRelatory(),
        ]
    }

    private routeVectorQuantificationRelatory(): JSX.Element {
        var viewModel = new VectorQuantificationRelatoryViewModel()
        return (<ProtectedRoute requiredPermissions={['relatorios.quant_vetores.*']} path="/:base/relatorio/quantificacao-vetores" exact={true} component={(props: any) => {
            return (<VectorQuantificationRelatoryViewController
                navigation={props}
                viewModel={viewModel}
                delegate={this}
            />)
        }} />)
    }

    tapDimiss(navigation: any): void {
        navigation.history.goBack();
    }
}